<template>
    <div class="aup-vertical-divider d-inline-block h-100">
        <slot/>
    </div>
</template>
<script>
	export default {
        name: "BaseVerticalDivider",
    };
</script>

<style lang="scss">
    @import "../../assets/scss/all";
    .aup-vertical-divider {
        background-color: $gray-400;
        width: 1px;
    }
</style>
